<template>
  <v-layout row class="align-center layout px-4 pt-4 app--page-header">
    <!-- <div class="page-header-left">
      <h3 class="pr-3">{{title}}</h3>
    </div> -->

    <!-- <v-breadcrumbs divider="-">
      <v-breadcrumbs-item>
      <v-icon>home</v-icon>
      </v-breadcrumbs-item>
      <v-breadcrumbs-item v-for="(item,key) in breadcrumbs" :key="key">
      {{ item }}
      </v-breadcrumbs-item>
    </v-breadcrumbs> -->

    <v-breadcrumbs :items="breadcrumbs" class="px-0">
      <template v-slot:divider>
        <v-icon>chevron_right</v-icon>
      </template>
      <v-breadcrumbs-item
        slot="item"
        slot-scope="{ item }"
      >
        {{ item }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-spacer></v-spacer>
    <div class="page-header-right"></div>
  </v-layout>  
</template>

<script>
  import menu from '@/api/menu';

  export default {
    data() {
      return {
        title: ''
      };
    },

    computed: {
      breadcrumbs: function () {
        let breadcrumbs = [];

        menu.forEach(menuItem => {
          if (menuItem.items) {
            let child =  menuItem.items.find(i => {
              return i.component === this.$route.name;
            });

            if (child) {
              breadcrumbs.push(menuItem.title);
              breadcrumbs.push(child.title);
              this.title = child.title;
            }
          } else {
            if (menuItem.name === this.$route.name) {
              this.title = menuItem.title;
              breadcrumbs.push(menuItem.title);
            }
          }
        });

        return breadcrumbs;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/PageHeader.vue